import HeaderBar from "../../../Components/UI/headerbar";
import Reviews from "../../../Components/technicalSupport/reviews";

const ReviewsPage = () => {
  return (
    <div class="container-fluid">
      <div class="row">
        <HeaderBar
          title={"مركز الدعم"}
          content={"إدارة طلبات الدعم ومحادثات النظام"}
        />

        <div className="col-12">
          <Reviews />
        </div>
      </div>
    </div>
  );
};

export default ReviewsPage;
